import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';

const { Content } = Layout;

const PageView = () => {
  return (
    <Layout className="page-view">
      <Content className="page-content">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default PageView;
